import { render, staticRenderFns } from "./PackageDetails.vue?vue&type=template&id=00efe368&scoped=true"
import script from "./PackageDetails.vue?vue&type=script&lang=js"
export * from "./PackageDetails.vue?vue&type=script&lang=js"
import style0 from "./PackageDetails.vue?vue&type=style&index=0&id=00efe368&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00efe368",
  null
  
)

export default component.exports